import type { Message } from "revolt.js";

import { getDisplayName } from "./displayName";
import { getRolesInChannel } from "./getRolesInChannel";
import { prepareNotificationBody } from "./notificationBody";

export function prepareTextForNotification(message: Message): string {
    const text = message.content;
    if (!text) {
        return "";
    }

    const users = message.client?.users;
    const channelRoles = message.channel
        ? getRolesInChannel(message.channel)
        : [];

    return prepareNotificationBody(
        text,
        (id) => {
            const user = users?.get(id);
            return user ? getDisplayName(user) : undefined;
        },
        (id) => channelRoles.find((role) => role.id === id)?.name,
    );
}
